"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const ReportingEnums_1 = require("../../../__types/__enums/ReportingEnums");
const getAllDashboards_1 = require("./getAllDashboards");
const getPaginatedDashboards_1 = require("./getPaginatedDashboards");
function getDashboards(rp, input) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const reportInput = input.ReportParams;
        const { requestType } = reportInput;
        switch (requestType) {
            case ReportingEnums_1.ReportRequestTypeEnum.ALL:
                return getAllDashboards_1.getAllDashboards(rp, input);
            case ReportingEnums_1.ReportRequestTypeEnum.PAGINATED:
                return getPaginatedDashboards_1.getPaginatedDashboards(rp, input);
            default:
                throw new Error('Invalid request type');
        }
    });
}
exports.getDashboards = getDashboards;
//# sourceMappingURL=index.js.map